import makeCrudMetaReducer from 'weego-common/src/utils/makeCrudMetaReducer';
import { actionTypes as demandsActionTypes } from '../../actions/demands';

export default makeCrudMetaReducer(demandsActionTypes);
